import { useEffect, useState } from "react";

import DstButton from "../../../../components/DstButton/DstButton";
import MeetingBlock from "../../../../components/MeetingBlock/MeetingBlock";
import translate from "../../../../services/Translate";
import { fetchUserMeetings } from "./UserMeetings.function";

const _meetingTypeNamePrettier = (str: string) => str.replace(/[-_]/gm, " ");

const UserMeetings = ({ language, userId }: { language: string; userId: number }): JSX.Element => {
  const [meetings, setMeetings] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState("");
  const [sortHistoryTime, setSortHistoryTime] = useState<"asc" | "desc">("desc");
  const meetingTypes: Array<string> = ["All"].concat(Array.from(new Set(meetings.map((meeting) => meeting.type_name))));
  const refreshUserMeetings = () => fetchUserMeetings(userId, setMeetings, setLoading);

  useEffect(() => {
    fetchUserMeetings(userId, setMeetings, setLoading);
  }, [userId]);

  return (
    <div className="w-100 px-3">
      <div className="mb-3">
        {!loading ? (
          meetingTypes.map((type: string) => (
            <DstButton
              key={type}
              variant="info"
              clickFunction={() => setFilterType(type === "All" ? "" : type)}
              btnClass={`text-capitalize me-2 ${
                filterType === type || (filterType === "" && type === "All") ? "active-filter-btn" : ""
              }`}
              value={_meetingTypeNamePrettier(type)}
            />
          ))
        ) : (
          <div className="d-flex">
            <DstButton mock btnWidth="41px" btnClass="me-2" />
            <DstButton mock btnWidth="90px" />
          </div>
        )}
      </div>
      <h2>{translate(language, "PAGES.USER.MEETING.UPCOMING_TITLE")}</h2>
      {!loading ? (
        meetings.filter((meeting: any) => !!meeting.is_future && ["", meeting.type_name].includes(filterType)).length >
        0 ? (
          meetings
            .filter((meeting: any) => !!meeting.is_future && ["", meeting.type_name].includes(filterType))
            .map((meeting: any, index: number) => (
              <MeetingBlock
                key={`future-meeting-${index}`}
                meeting_type={meeting.type?.name}
                {...meeting}
                language={language}
                refreshUserMeetings={refreshUserMeetings}
              />
            ))
        ) : (
          <p className="gray-font py-2">{translate(language, "PAGES.USER.MEETING.NO_MEETING_CORRESPONDING")}</p>
        )
      ) : (
        [...Array(3)].map((_elem, index) => (
          <MeetingBlock key={`mock-future-meeting-${index}`} mock={true} language={language} />
        ))
      )}

      <h2>
        {translate(language, "PAGES.USER.MEETING.PAST_TITLE")}
        <DstButton
          btnClass="float-end"
          variant="secondary"
          clickFunction={() => setSortHistoryTime((sort) => (sort === "desc" ? "asc" : "desc"))}
          btnImageBefore={
            <span
              className={`align-text-bottom pe-2 dst-icon-arrow-narrow-${sortHistoryTime === "asc" ? "down" : "up"}`}
            />
          }
          value={translate(language, "PAGES.USER.MEETING.CHRONOLOGICAL_BUTTON_TEXT")}
        />
      </h2>
      {!loading ? (
        meetings.filter((meeting: any) => !meeting.is_future && ["", meeting.type_name].includes(filterType)).length >
        0 ? (
          meetings
            .filter((meeting: any) => !meeting.is_future && ["", meeting.type_name].includes(filterType))
            .sort((a: any, b: any) => b.dt_start.getTime() - a.dt_start.getTime() * +(sortHistoryTime === "desc"))
            .map((meeting: any, index: number) => (
              <MeetingBlock
                key={`past-meeting-${index}`}
                meeting_type={meeting.type?.name}
                {...meeting}
                language={language}
                refreshUserMeetings={refreshUserMeetings}
              />
            ))
        ) : (
          <p className="gray-font py-2">{translate(language, "PAGES.USER.MEETING.NO_MEETING_CORRESPONDING")}</p>
        )
      ) : (
        [...Array(3)].map((_elem, index) => (
          <MeetingBlock key={`mock-past-meeting-${index}`} mock={true} language={language} />
        ))
      )}
    </div>
  );
};

export default UserMeetings;
